import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 2 - 타이틀 + 카드형 컨텐츠 박스
 * 원본: banner-card fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} subtitle - 서브타이틀
 * @param {string} description - 설명
 */
const BannerCard = ({ title, breadcrumbPath, subtitle = '', description = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';
  const hasDescription = description && description.trim() !== '';

  return (
    <>
      <style>
        {`
          .banner-card {
            background: #f8f9fa;
            padding: 20px 0;
            border-bottom: 3px solid #e6e9ec;
          }
          .banner-card .banner-card-box {
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            padding: 40px;
            margin: 0 auto;
          }
          .banner-card .banner-title {
            font-size: 2.5rem;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 15px;
            border-bottom: 3px solid var(--theme-color-secondary);
            padding-bottom: 15px;
          }
          .banner-card .banner-subtitle {
            font-size: 1.3rem;
            color: #555;
            margin-bottom: 15px;
            font-weight: 500;
          }
          .banner-card .banner-description {
            font-size: 1rem;
            color: #777;
            line-height: 1.6;
            margin-bottom: 20px;
          }
          .banner-card .banner-breadcrumb {
            font-size: 0.9rem;
            color: #999;
            padding-top: 15px;
            border-top: 1px solid #eee;
          }
          .banner-card .banner-breadcrumb a {
            color: var(--theme-color-secondary);
            text-decoration: none;
          }
          .banner-card .banner-breadcrumb a:hover {
            text-decoration: underline;
          }
        `}
      </style>
      <div className="banner-card">
        <div className="container">
          <div className="banner-card-box">
            <h1 className="banner-title" data-aos="fade-right" data-aos-delay="100">
              {escapeHtml(pageTitle)}
            </h1>
            {hasSubtitle && (
              <p className="banner-subtitle" data-aos="fade-left" data-aos-delay="100">
                {escapeHtml(subtitle)}
              </p>
            )}
            {hasDescription && (
              <p className="banner-description" data-aos="fade-left" data-aos-delay="100">
                {escapeHtml(description)}
              </p>
            )}
            <div className="banner-breadcrumb" data-aos="fade-left" data-aos-delay="100">
              {menuPath}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerCard;

